/**
 * Adds a class to selected elements when you scroll past the top of them
*/
EventBus.subscribe('run-modules', function () {
    
    //Cancel if no elements found
    var elements = jQuery('.scroll-top-target');
    if (elements.length === 0) {
        return;
    }
    
    var
        element,
        scrollPosition
    ;
    
    jQuery(document).scroll(function () {
        
        scrollPosition = jQuery(window).scrollTop();
        
        elements.each(function () {
            element = jQuery(this);
            scrollPosition >= element.offset().top ? element.addClass('scrolled-past-top') : element.removeClass('scrolled-past-top');
        });
        
    });
    
});